import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Users } from "lucide-react";

/** Compact live audience counter — polls /audience/live every 15s. */
const LiveAudienceCounter = ({ channel = "total", className = "" }) => {
  const [count, setCount] = useState(null);
  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const { data } = await api.get("/audience/live");
        if (mounted) setCount(data[channel] ?? 0);
      } catch {
        if (mounted) setCount(0);
      }
    };
    load();
    const t = setInterval(load, 15000);
    return () => {
      mounted = false;
      clearInterval(t);
    };
  }, [channel]);

  if (count === null) return null;
  return (
    <span
      data-testid={`audience-counter-${channel}`}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-white/10 text-white text-xs font-bold ${className}`}
    >
      <Users className="w-3.5 h-3.5" />
      <span>{count.toLocaleString("pt-BR")}</span>
      <span className="text-white/60 font-medium uppercase tracking-widest text-[10px]">
        agora
      </span>
    </span>
  );
};

export default LiveAudienceCounter;
